import {
    Box,
    Button,
    Grid2 as Grid,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import React from "react";
import { SectionPaper, TagsHighlightSelect, TextField } from "../../components";
import { PublishedIcon } from "../../images/svg/publishedIcon";
import { WIPIcon } from "../../images/svg/WIPIcon";
import { SelectBoxOption } from "../../interfaces/selectBox";
import { TAG_CANONICAL_NAMES } from "../../utils";
import { CheckListContext } from "../viewCheckList/viewCheckListDetail";

export const documentTemplateStatus = [
    { value: "Draft", label: "Draft" },
    { value: "Published", label: "Published" }
]

export const BasicDetails: React.FC<{ isEdit: boolean; isPublished: boolean; onPublish: () => void; children?: JSX.Element }> = (props) => {

    const { state, updateState, error } = React.useContext(CheckListContext);

    const isPublished = props.isPublished;

    return (
        (<SectionPaper
            py={0.2}
            title="Basic Details"
            renderButtons={props.isEdit ? [
                isPublished
                    ? <Stack direction={"row"} sx={{
                        alignItems: "center"
                    }}>
                        <Typography variant="body2" color="textSecondary">Status: </Typography><Button disableRipple disableFocusRipple sx={{ cursor: "default", '&:hover': { backgroundColor: 'transparent' } }}>
                            <Tooltip
                                title="Published"
                                children={<Box
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}><PublishedIcon sx={{ width: "100%", height: "100%" }} /></Box>}
                            />
                        </Button>
                    </Stack>
                    : <Stack direction={"row"} sx={{
                        alignItems: "center"
                    }}>
                        <Typography variant="body2" color="textSecondary">Status: </Typography>
                        <Button onClick={props.onPublish} disableRipple disableFocusRipple sx={{ '&:hover': { backgroundColor: 'transparent' } }}><Tooltip title="Work in progress" children={<Box
                            sx={{
                                width: 30,
                                height: 30,
                                alignItems: "center",
                                justifyContent: "center"
                            }}><WIPIcon sx={{ width: "100%", height: "100%" }} /></Box>} /></Button>
                    </Stack>
            ] : []}
        >
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        lg: 4
                    }}>
                    <TextField
                        id="datasheet-name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        required={true}
                        value={state.name}
                        error={error.name}
                        helperText={error.name ? "Please fill Data sheet Name" : ""}
                        label={"Data Sheet Name"}
                        onChange={(e) => updateState("name", e.target.value)}
                        viewOnly={isPublished}
                    />
                </Grid>

                {/* Description*/}
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        lg: 4
                    }}>
                    <TextField
                        id="datasheet-desc"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={state.description}
                        label={"Data Sheet Description"}
                        onChange={(e) => updateState("description", e.target.value)}
                        viewOnly={isPublished}
                    />
                </Grid>

                {/* <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        lg: 4
                    }}>
                    <HighlightSelectBox
                        id="datasheet-status"
                        label={"Data Sheet Status"}
                        margin={"none"}
                        required={true}
                        value={state.status}
                        error={error.status}
                        helperText={error.status ? "Please fill Datasheet Status" : ""}
                        options={dataSheetStatus}
                        onChange={(data: SelectBoxOption) => updateState("status", data)}
                        viewOnly={isPublished}
                    />
                </Grid> */}

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        lg: 4
                    }}>
                    <TagsHighlightSelect
                        id="datasheet-tags"
                        margin={"none"}
                        required={true}
                        value={state.tags_info}
                        multiple={true}
                        error={error.tags_info}
                        helperText={error.tags_info ? "Please fill the Tags" : ""}
                        onChange={(data: SelectBoxOption) => updateState("tags_info", data)}
                        viewOnly={isPublished}
                        canonical_name={TAG_CANONICAL_NAMES.ds_tg}
                    />
                </Grid>
            </Grid>
        </SectionPaper>)
    );
};
